import React from 'react';
import { resetStyles, setStyles } from './scroll-doctor-copy';

const isomorphicUseLayoutEffect =
    typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;

export function useScrollLockFix() {
    isomorphicUseLayoutEffect(() => {
        // Workaround for scroll lock not being removed when Warp React Modal
        // component is unmounted. This is a temporary fix until the issue is
        // resolved in the Warp component.
        setStyles();
        return () => resetStyles();
    }, []);
}
